module.exports = __webpack_public_path__ + "static/media/pk-pro-cover.dc2f98a0.jpg";